import React from 'react';
import { REPORT_PRINT_THEME, REPORT_PRINT_TYPO } from '../../../utils/dailyReport/reportPrintTheme';

const fieldStyle = {
  marginBottom: '14px',
};

const labelStyle = {
  ...REPORT_PRINT_TYPO.label,
  color: REPORT_PRINT_THEME.textMedium,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  marginBottom: '4px',
};

const valueStyle = {
  ...REPORT_PRINT_TYPO.body,
  color: REPORT_PRINT_THEME.text,
  lineHeight: 1.45,
  whiteSpace: 'pre-wrap',
};

function FieldBlock({ label, value, fallback = '—' }) {
  const display = value != null && String(value).trim() !== '' ? String(value) : fallback;
  return (
    <div style={fieldStyle}>
      <div style={labelStyle}>{label}</div>
      <div style={valueStyle}>{display}</div>
    </div>
  );
}

const PrintReportSummary = ({ narrative, reportDateLabel }) => {
  const n = narrative || {};

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '1000px',
        padding: '8px 0',
        background: REPORT_PRINT_THEME.background,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '12px 24px',
          marginBottom: '18px',
          padding: '12px 14px',
          background: REPORT_PRINT_THEME.backgroundAlt,
          border: `1px solid ${REPORT_PRINT_THEME.border}`,
          borderRadius: '6px',
        }}
      >
        <div>
          <div style={labelStyle}>Compiled By</div>
          <div style={{ ...REPORT_PRINT_TYPO.body, color: REPORT_PRINT_THEME.text, fontWeight: 600 }}>
            {n.compiled_by?.trim() || '—'}
          </div>
        </div>
        <div>
          <div style={labelStyle}>Date</div>
          <div style={{ ...REPORT_PRINT_TYPO.body, color: REPORT_PRINT_THEME.text, fontWeight: 600 }}>
            {reportDateLabel || '—'}
          </div>
        </div>
      </div>

      <FieldBlock label="Positive Safety Observation" value={n.positive_safety_observation} />
      <FieldBlock label="Incidents" value={n.incidents} />
      <FieldBlock label="Safety Toolbox Topic" value={n.safety_toolbox_topic} />
      <FieldBlock label="Geology Meeting Topic" value={n.geology_meeting_topic} />
    </div>
  );
};

export default PrintReportSummary;
